module.exports = __webpack_public_path__ + "img/wholesaleIcon10.415b43a4.png";